export const frontmatter = {
    "draft": true,
    "title": "SDK de Node.js / TypeScript",
    "description": "Librería oficial de OnnIA para integrar flujos, mensajería y agentes en aplicaciones Node.js y TypeScript.",
    "sidebar_label": "Node.js / TS",
    "sidebar_group": "referencia",
    "sidebar_order": 1
}

export const toc = [
    {
        "depth": 2,
        "id": "instalacion",
        "value": "Instalación"
    },
    {
        "depth": 2,
        "id": "inicializacion",
        "value": "Inicialización"
    },
    {
        "depth": 2,
        "id": "ejemplos-de-uso",
        "value": "Ejemplos de uso"
    },
    {
        "depth": 3,
        "id": "enviar-un-mensaje-por-canal",
        "value": "Enviar un mensaje por canal"
    },
    {
        "depth": 3,
        "id": "iniciar-ejecucion-de-workflow",
        "value": "Iniciar ejecución de Workflow"
    }
]